import React from "react"
import {Formik} from "formik"
import * as Yup from "yup"
import TextField from "../../../Address/Textfield"
import DocumentTypeHeader from "./DocumentTypeHeader"
import {ApplicationDocumentType} from "../../../../resources/application"
import {CertificateOfIncorporationDocumentFormValues} from "./types"
import {nameValidation, validationErrorMessages} from "./validationSchemas"

interface CertificateOfIncorporationDocumentFormProps {
	documentType: ApplicationDocumentType
	initialValues: CertificateOfIncorporationDocumentFormValues
	onSubmit: (values: CertificateOfIncorporationDocumentFormValues) => void
	formId: string
}

const validationSchema = Yup.object().shape({
	businessName: nameValidation,
	stateOfIncorporation: Yup.string().required(validationErrorMessages.stateOfIncorporation.required),
})

export const CertificateOfIncorporationDocumentForm = ({
	documentType,
	initialValues,
	onSubmit,
	formId,
}: CertificateOfIncorporationDocumentFormProps) => {
	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
			{({values, handleChange, handleBlur, handleSubmit}) => (
				<form onSubmit={handleSubmit} id={formId} className="edit-document-form">
					<div className="key-value-card-container-key">Type</div>
					<DocumentTypeHeader documentType={documentType} />

					<div className="key-value-card-container-key">Business Name</div>
					<TextField
						className="input-blank-label"
						label=""
						placeholder="Enter business name"
						name="businessName"
						value={values.businessName}
						onChange={handleChange}
						onBlur={handleBlur}
					/>

					<div className="key-value-card-container-key">State of Incorporation</div>
					<TextField
						className="input-blank-label"
						label=""
						placeholder="Enter state of incorporation"
						name="stateOfIncorporation"
						value={values.stateOfIncorporation}
						onChange={handleChange}
						onBlur={handleBlur}
					/>
				</form>
			)}
		</Formik>
	)
}
